import { render } from "./InstallerLayout.vue?vue&type=template&id=169e4e0b&scoped=true"
import script from "./InstallerLayout.vue?vue&type=script&lang=js"
export * from "./InstallerLayout.vue?vue&type=script&lang=js"

import "./installer-layout.scss?vue&type=style&index=0&id=169e4e0b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169e4e0b"]])

export default __exports__